import React, { Fragment } from 'react';
import { DataContext } from './DataContext.js'
import Icon from '~/core/scripts/components/Icon';
import classnames from 'classnames';
import { is768Query } from '~/core/scripts/mediaquery-helper.js'

function dbnc(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms);
  };
}

const Navigation = function(props) {

  const [ state, updateState ] = React.useContext(DataContext);

  // use state to force rerender on viewport size change to trigger different views
  const [ update, doUpdate ] = React.useState(0);
  React.useEffect(() => {
    const u = ()=>doUpdate(update+1);
    window.addEventListener('resize', u);
    return _ => { window.removeEventListener('resize', u) }
  });
  
  function setCrime(index){
    updateState(function(st){
      return {
        crime: index,
        district: st.district,
        district_type: st.district_type, 
        district_label: st.district_label, 
        district_extra: st.district_extra, 
        crimeData: st.crimeData,
        colorSteps: st.colorSteps,
        maxv: st.maxv
      };
    });
  }
  
  function nextCrime(){
    updateState(function(st){
      return {
        crime: ((state.crime+1)%state.crimeData.delicts.length),
        district: st.district,
        district_type: st.district_type, 
        district_label: st.district_label, 
        district_extra: st.district_extra, 
        crimeData: st.crimeData,
        colorSteps: st.colorSteps,
        maxv: st.maxv
      };
    });
  }
  
  function prevCrime(){
    updateState(function(st){
      return {
        crime: ((state.crime+1)%state.crimeData.delicts.length),
        district: st.district,
        district_type: st.district_type, 
        district_label: st.district_label, 
        district_extra: st.district_extra, 
        crimeData: st.crimeData,
        colorSteps: st.colorSteps,
        maxv: st.maxv
      };
    });
  }
  
  
  return (
    <div className="navigation">
      {is768Query() && state.crimeData.delicts.map(function(delict,index){ 
        return (
          <div 
            key={`item-${index}`}
            className={classnames('item', { 'is-active': state.crime === index })}
            onClick={() => setCrime(index)}
          >
            <Icon type={delict.id} />
            <div className="label">{delict.label}</div>
          </div>
        )
      })}
      {!is768Query() && ( // small
        <Fragment>
          <button className="btn prev circle" onClick={() => prevCrime()}>
            <Icon type="down" />
          </button>
          <div className="crime is-active">
            <Icon type={state.crimeData.delicts[state.crime].id} />
            <div className="label">{state.crimeData.delicts[state.crime].label}</div>
          </div>
          <button className="btn next circle" onClick={() => nextCrime()}>
            <Icon type="down" />
          </button>
        </Fragment>
      )}
    </div>
  );
};

export default Navigation;
